import React from "react";
import { Button, Checkbox } from "../../../common";
import * as style from "../styles.module.scss";

const contractForServices = ({
  handleSubmit,
  handleBack,
  state,
  errors,
  handleChange,
  candidateName,
  dateSigned,
}) => {
  return (
    <form
      className={`col-sm-12 col-lg-6 mt-2 mt-lg-4 mb-2 ${style.form}`}
      onSubmit={handleSubmit}
    >
      <div className={`mb-3`}>
        <a
          className={style.workHistory__link}
          href={"/api/candidate-account/contract-for-services"}
          download
        >
          HRGO contract for services
        </a>
        <div className="form-group mt-2">
          <Checkbox
            label="I have read and understood the information in this contract and agree to the terms outlined in this document.*"
            isChecked={state.hasCFS}
            onClick={(e) => handleChange("hasCFS", e.target.checked)}
            disabled={state.cfsSubmitted}
            validationMessages={errors?.hasCFS}
          />
        </div>
        <div className="mt-2">
          <p className={style.titleGrey}>Signed</p>
          <p className={style.signature}>{candidateName}</p>
        </div>
        <div className="mt-2">
          <p className={style.titleGrey}>Print name</p>
          <p className={style.signature}>{candidateName}</p>
        </div>
        <div className="mt-2">
          <p className={style.titleGrey}>Date</p>
          <p className={style.signature}>{dateSigned}</p>
        </div>
      </div>
      <div className={`mt-lg-auto mb-lg-2 ${style.actions}`}>
        <Button
          classes="btn btn-outline-info text-dark mr-1"
          onClick={handleBack}
        >
          Back
        </Button>
        <Button classes="btn btn-primary btn-block">Next</Button>
      </div>
    </form>
  );
};

export default contractForServices;
